<template>
  <!-- <DBox
    :id="'cmp-booking-tasks-task_details-contact_relations-box'"
    :addButton="false"
    :addLink="false"
  > -->
    <NTable
        id="booking-tasks-task_details-contact_relations-table dbox1"
        :config="tableConfig"
        :headers="headers"
        :items="contactRelations"
        :showNoItems="true"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('type')">
            <span class="txtov" :title="item['type']">
              {{ item["type"] }}
            </span
            </td>
            <td v-bind="tdcon('contacts')">
              <span class="txtov" :title="item['name']">
                {{ item["name"] }}
              </span>
            </td>
            <td v-bind="tdcon('phone1')">
              <span class="txtov">
                {{ item["phone1"] }}
              </span>
            </td>
            <td v-bind="tdcon('phone2')">
              <span class="txtov">
                {{ item["phone2"] }}
              </span>
            </td>
            <td v-bind="tdcon('email')">
              <span class="txtov">
                {{ item["email"] }}
              </span>
            </td>
          </tr>
        </template>
      </NTable>
  <!-- </DBox> -->
</template>

<script>

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        footer: false,
      }),
      selectedContactTravels: new Set(),
    };
  },
  computed:{
    headers: function () {
      return [
        createTableHeader("type", {
          // text: false,
          // f: 1.7,
          // mw: 200,
        }),
        createTableHeader("contacts", {
          // text: "Status",
          // ta: "left",
          // f: 0.5,
        }),
        createTableHeader("phone1", { ta: "left" }),
        createTableHeader("phone2"),
        createTableHeader("email")
      ];
    }, 
  },
  props: ["contactRelations"],
  methods: {
    
  },
};
</script>

<style lang="scss">
.booking-tasks-task_details-contact_relations-table {
  --ntable-height: auto !important;
}
</style>
